export default __webpack_public_path__ + "static/h09-8e638114d6ab512c5e28281ba627dc27.png";